<template>
  <div class="my-3 padding-container__courses">
    <div class="row form-group">
      <div class="col-md-12 px-0">
        <card class="top-filters" type="white" header-classes="bg-transparent">
          <div class="row form-group align-items-center">
            <div
              class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-6 reports-select"
            >
              <label for="card-name" class="text-maquillate2"
                >Cursos disponibles</label
              >

              <multiselect
                v-model="course"
                :options="getPartnerCoursess"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
                placeholder="Filtrar por curso"
                track-by="name"
                label="name"
                :allow-empty="true"
                @select="selectedCourse"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <strong>{{ option.name }}</strong>
                </template>
                <template #noResult>
                  <div>Sin resultados</div>
                </template>
              </multiselect>
            </div>

            <div
              class="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-6 reports-select reports-select__partner"
            >
              <label for="card-name" class="text-maquillate2"
                >Filtro de fechas</label
              >

              <div class="nav-data-picker calendary-input">
                <!-- Date picker -->
                <date-range-picker
                  ref="picker"
                  v-model="dateRange"
                  :locale-data="{ firstDay: 1, format: 'dd-mm-yyyy HH:mm:ss' }"
                  :timePicker="true"
                  :timePicker24Hour="true"
                  @update="updateDateRange"
                >
                  <template v-slot:input="picker" style="min-width: 350px">
                    <span
                      v-if="picker.startDate"
                      class="select-date-calendary size-calendary-reports__partner"
                    >
                      <i class="far fa-calendar-alt"></i>
                      {{ getDatePickerFormat(picker.startDate) }} -
                      {{ getDatePickerFormat(picker.endDate) }}
                    </span>
                    <span class="size-calendary-reports__partner" v-else
                      ><i class="far fa-calendar-alt"></i> Selecciona fecha a
                      consultar</span
                    >
                  </template>
                </date-range-picker>

                <base-button
                  @click="clearDateRange"
                  class="ml-2 mt-1"
                  type="primary btn-maquillate"
                  >Limpiar filtro</base-button
                >
              </div>
            </div>
          </div>
        </card>
      </div>
    </div>
    <div class="row form-group">
      <div class="col-12" v-if="course">
        <div v-if="getGeneralStats" class="row general-stats-container">
          <card
            v-for="(stat, index) in getGeneralStats"
            :key="index"
            class="general-stats-container__box"
            type="white"
            header-classes="bg-transparent"
          >
            <div
              slot="header"
              class="row general-stats-container__box__header justify-content-center text-maquillate2"
            >
              <h3 class="text-maquillate2">{{ stat.title }}</h3>
            </div>
            <h3>
              <span v-if="stat.type == 'currency'"
                >$ {{ Number.parseFloat(stat.total).toFixed(2) }}</span
              >

              <span v-else-if="stat.type == 'count'">{{
                stat.total || 0
              }}</span>
            </h3>

            <span
              v-if="stat.increase != null"
              :class="{
                'chart_increase chart_increase--positive': stat.increase > 0,
                'chart_increase chart_increase-negative': stat.increase < 0,
                'chart_increase chart_increase--neutro': stat.increase == 0,
              }"
            >
              <i v-if="stat.increase > 0" class="fas fa-long-arrow-alt-up"></i>
              <i
                v-else-if="stat.increase < 0"
                class="fas fa-long-arrow-alt-down"
              ></i>
              {{ stat.increase.toFixed(2) }}%
            </span>
          </card>
        </div>

        <div class="row">
          <card
            class="col-12 custom-chart"
            type="white"
            header-classes="bg-transparent"
          >
            <div slot="header" class="row align-items-center">
              <div class="col-4">
                <h6
                  class="text-light text-uppercase ls-1 mb-1 text-maquillate2"
                >
                  Estadisticas
                </h6>
                <h5 class="h3 mb-0 text-maquillate2">
                  Ganancias netas por curso
                </h5>
                <div
                  :class="{
                    'chart_increase chart_increase--positive':
                      this.increaseValues.profit_revenue > 0,
                    'chart_increase chart_increase-negative':
                      this.increaseValues.profit_revenue < 0,
                    'chart_increase chart_increase--neutro':
                      this.increaseValues.profit_revenue == 0,
                  }"
                >
                  <span>
                    {{ this.increaseValues.profit_revenue }}%
                    <i
                      v-if="this.increaseValues.profit_revenue > 0"
                      class="fas fa-long-arrow-alt-up"
                    ></i>
                    <i
                      v-else-if="this.increaseValues.profit_revenue < 0"
                      class="fas fa-long-arrow-alt-down"
                    ></i>
                  </span>
                </div>
              </div>
              <div class="col-8">
                <ul class="nav nav-pills justify-content-end">
                  <li class="nav-item">
                    <a
                      class="nav-link py-2 px-3"
                      href="#"
                      :class="{ active: bigLineChart.activeIndex === 1 }"
                      @click.prevent="
                        selectedCourse(course, 'period=yearly', 1)
                      "
                    >
                      <span class="d-none d-md-block">Anual</span>
                      <span class="d-md-none">A</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link py-2 px-3"
                      href="#"
                      :class="{ active: bigLineChart.activeIndex === 2 }"
                      @click.prevent="
                        selectedCourse(course, 'period=monthly', 2)
                      "
                    >
                      <span class="d-none d-md-block">Mensual</span>
                      <span class="d-md-none">A</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link py-2 px-3"
                      href="#"
                      :class="{ active: bigLineChart.activeIndex === 3 }"
                      @click.prevent="selectedCourse(course, 'period=daily', 3)"
                    >
                      <span class="d-none d-md-block">30d</span>
                      <span class="d-md-none">M</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link py-2 px-3"
                      href="#"
                      :class="{ active: bigLineChart.activeIndex === 4 }"
                      @click.prevent="
                        selectedCourse(course, 'period=daily&days=7', 4)
                      "
                    >
                      <span class="d-none d-md-block">7d</span>
                      <span class="d-md-none">7d</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link py-2 px-3"
                      href="#"
                      :class="{ active: bigLineChart.activeIndex === 5 }"
                      @click.prevent="
                        selectedCourse(course, 'period=hourly&hours=48', 5)
                      "
                    >
                      <span class="d-none d-md-block">48h</span>
                      <span class="d-md-none">48h</span>
                    </a>
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link py-2 px-3"
                      href="#"
                      :class="{ active: bigLineChart.activeIndex === 6 }"
                      @click.prevent="
                        selectedCourse(course, 'period=hourly&hours=24', 6)
                      "
                    >
                      <span class="d-none d-md-block">24h</span>
                      <span class="d-md-none">24h</span>
                    </a>
                  </li>
                  <li class="nav-item mr-2 mr-md-0">
                    <a
                      class="nav-link py-2 px-3"
                      href="#"
                      :class="{ active: bigLineChart.activeIndex === 0 }"
                      @click.prevent="selectedCourse(course, null, 0)"
                    >
                      <span class="d-none d-md-block">Toda</span>
                      <span class="d-md-none">T</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <line-chart
              v-if="course"
              :key="bigLineChart.activeIndex"
              :height="350"
              :width="950"
              ref="bigChart"
              :chart-data="bigLineChart.chartData"
              :extra-options="bigLineChart.extraOptions"
            >
            </line-chart>
          </card>

          <!-- <card
            class="col-12 last-orders"
            type="default"
            header-classes="bg-transparent"
          >
            <el-table
              v-if="getLastOrders"
              class="table-responsive table-flush order-last-list"
              header-row-class-name="thead-light"
              :data="getLastOrders.orders"
            >
              <el-table-column
                label="Información de cliente"
                min-width="150px"
                prop="code"
                sortable
              >
                <template v-slot="{ row }">
                  <div class="media align-items-center">
                    <div class="media-body">
                      <span class="font-weight-500 name mb-0 text-sm">
                        <div class="customer-info">
                          <h2>{{ row.user.name }}</h2>
                          <span>{{ row.user.email }}</span>
                        </div>
                      </span>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="Fecha" prop="enable" sortable>
                <template v-slot="{ row }">
                  <div class="media align-items-center">
                    <div class="media-body order-date">
                      <span class="font-weight-500 name mb-0 text-sm">
                        {{ getDateFormat(row.created_at) }}
                      </span>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="Cupón aplicado" prop="discoun" sortable>
                <template v-slot="{ row }">
                  <div class="media align-items-center">
                    <div class="media-body order-coupon">
                      <span v-if="row.coupon_id">
                        {{ row.coupon.code }}
                      </span>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="Monto" prop="expiration" sortable>
                <template v-slot="{ row }">
                  <div class="media align-items-center">
                    <div class="media-body order-amount">
                      <span class="font-weight-500 name mb-0 text-sm">
                        ${{ row.total }}
                      </span>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </card> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

import { mapGetters } from 'vuex';
import { PARTNER_GET_ALL_COURSES } from '@/store/actions/partner';
import {
  CHARTS_GET_PROFIT_REVENUE_BY_COURSE_DATA,
  CHARTS_GET_LAST_ORDERS_BY_COURSE_DATA,
  CHARTS_GET_GENERAL_STATS_BY_COURSE_DATA,
  CHARTS_GET_TOP_COURSES,
  CHARTS_GET_TOP_CUSTOMERS,
} from '@/store/actions/charts';
import DoughnutChart from '@/components/Charts/DoughnutChart';
import LineChart from '@/components/Charts/LineChart';
import BarChart from '@/components/Charts/BarChart';
import PieChart from '@/components/Charts/PieChart';
import * as chartConfigs from '@/components/Charts/config';

import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from 'element-ui';

import moment from 'moment-timezone';

import Multiselect from 'vue-multiselect';

import DateRangePicker from 'vue2-daterange-picker';

import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
  name: 'PartnerCourses',
  components: {
    Multiselect,
    //DoughnutChart,
    LineChart,
    //BarChart,
    //PieChart,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    DateRangePicker,
  },
  data() {
    return {
      courses: null,
      course: null,
      increaseValues: {
        profit_revenue: 0,
      },
      bigLineChart: {
        allData: [],
        activeIndex: 0,
        chartData: {},
      },
      dateRange: {
        startDate: null,
        endDate: null,
      },
    };
  },
  mounted() {
    this.$store
      .dispatch(PARTNER_GET_ALL_COURSES)
      .then((resp) => {
        console.log(resp.data);
        console.log(this.getPartnerCoursess);
      })
      .catch((err) => {});
  },
  methods: {
    dateFormat(classes, date) {
      if (!classes.disabled) {
        classes.disabled = date.getTime() < new Date();
      }
      return classes;
    },
    updateDateRange(date) {
      let query = '';
      if (!date.startDate && !date.endDate) {
        return (query = null);
      }

      let data = {
        course_id: this.course.id,
        filter: query
          ? query
          : `period=custom&startDate=${moment(
              date.startDate,
            ).format()}&endDate=${moment(date.endDate).format()}`,
      };

      this.$store
        .dispatch(CHARTS_GET_PROFIT_REVENUE_BY_COURSE_DATA, data)
        .then((resp) => {
          /*
           * Increase Values
           */
          this.increaseValues.profit_revenue = resp.data.increase.value;
          let indexChart = 0;
          let labels = Object.entries(resp.data.ticks)
            .map(function (date, index) {
              return _.map(date[1], (value, key) => {
                switch (indexChart) {
                  case 0: {
                    let dateformat = date[0] + ' ' + value.end;
                    return dateformat;
                    break;
                  }
                  case 1: {
                    return moment
                      .tz(value.end, 'America/New_York')
                      .format('YYYY');
                    break;
                  }
                  case 2: {
                    return moment
                      .tz(value.end, 'America/New_York')
                      .format('MMMM Y');
                    break;
                  }
                  case 3: {
                    return moment
                      .tz(value.end, 'America/New_York')
                      .format('YYYY-MM-DD');
                    break;
                  }
                  case 4: {
                    return moment
                      .tz(value.end, 'America/New_York')
                      .format('YYYY-MM-DD');
                    break;
                  }
                  case 5: {
                    return moment
                      .tz(value.end, 'America/New_York')
                      .format('YYYY-MM-DD h:mm a');
                    break;
                  }
                  case 6: {
                    return moment
                      .tz(value.end, 'America/New_York')
                      .format('YYYY-MM-DD h:mm a');
                    break;
                  }
                }
              });
            })
            .flat();

          let values = Object.entries(resp.data.ticks)
            .map(function (date, index) {
              return _.map(date[1], (value, key) => {
                return value.revenue;
              });
            })
            .flat();

          console.log(labels);
          console.log(values);

          this.setBigChart(indexChart, labels, values);
        })
        .catch((err) => {});

      this.$store
        .dispatch(CHARTS_GET_GENERAL_STATS_BY_COURSE_DATA, data)
        .then((resp) => {})
        .catch((err) => {});
    },
    clearDateRange() {
      this.dateRange = {
        startDate: null,
        endDate: null,
      };

      this.selectedCourse(this.course, 'period=all&N=3', 0);

      this.$store
        .dispatch(CHARTS_GET_GENERAL_STATS_BY_COURSE_DATA, {
          course_id: this.course.id,
          filter: '',
        })
        .then((resp) => {})
        .catch((err) => {});
    },
    selectedCourse(selectedOption, query, index) {
      let data = {
        course_id: selectedOption.id,
        filter: query ? query : 'period=all',
      };
      let indexChart = index ? index : 0;
      this.$store
        .dispatch(CHARTS_GET_PROFIT_REVENUE_BY_COURSE_DATA, data)
        .then((resp) => {
          /*
           * Increase Values
           */
          this.increaseValues.profit_revenue = resp.data.increase.value;

          let labels = Object.entries(resp.data.ticks)
            .map(function (date, index) {
              return _.map(date[1], (value, key) => {
                switch (indexChart) {
                  case 0: {
                    let dateformat = date[0] + ' ' + value.end;
                    return dateformat;
                    break;
                  }
                  case 1: {
                    return moment
                      .tz(value.end, 'America/New_York')
                      .format('YYYY');
                    break;
                  }
                  case 2: {
                    return moment
                      .tz(value.end, 'America/New_York')
                      .format('MMMM Y');
                    break;
                  }
                  case 3: {
                    return moment
                      .tz(value.end, 'America/New_York')
                      .format('YYYY-MM-DD');
                    break;
                  }
                  case 4: {
                    return moment
                      .tz(value.end, 'America/New_York')
                      .format('YYYY-MM-DD');
                    break;
                  }
                  case 5: {
                    return moment
                      .tz(value.end, 'America/New_York')
                      .format('YYYY-MM-DD h:mm a');
                    break;
                  }
                  case 6: {
                    return moment
                      .tz(value.end, 'America/New_York')
                      .format('YYYY-MM-DD h:mm a');
                    break;
                  }
                }
              });
            })
            .flat();

          let values = Object.entries(resp.data.ticks)
            .map(function (date, index) {
              return _.map(date[1], (value, key) => {
                return value.revenue;
              });
            })
            .flat();

          this.setBigChart(indexChart, labels, values);
        })
        .catch((err) => {});

      this.$store
        .dispatch(CHARTS_GET_LAST_ORDERS_BY_COURSE_DATA, data)
        .then((resp) => {})
        .catch((err) => {});

      this.$store
        .dispatch(CHARTS_GET_GENERAL_STATS_BY_COURSE_DATA, data)
        .then((resp) => {})
        .catch((err) => {});

      let tops = {
        filter: `courseid=${selectedOption.id}`,
      };

      this.$store
        .dispatch(CHARTS_GET_TOP_CUSTOMERS, tops)
        .then((resp) => {})
        .catch((err) => {});
    },
    setBigChart(index, labels, values) {
      let chart = {
        allData: [values],
        activeIndex: index,
        chartData: {
          datasets: [
            {
              label: 'Ingresos netos',
              data: values,
            },
          ],
          labels: labels,
        },
        extraOptions: chartConfigs.blueChartOptions,
      };

      this.bigLineChart = chart;
      this.bigLineChart.activeIndex = index;
    },
    getDateFormat(date) {
      return moment.tz(date, 'America/New_York').fromNow();
    },
    getDatePickerFormat(date) {
      return moment.tz(date, 'America/New_York').format('YYYY-MM-DD h:mm a');
    },
  },
  computed: {
    ...mapGetters([
      'getPartnerCoursess',
      'getLastOrders',
      'getGeneralStats',
      'getTopCourses',
      'getTopCustomers',
    ]),
  },
};
</script>

<style lang="scss">
.nav-data-picker {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 3px 0;

  .vue-daterange-picker {
    .form-control.reportrange-text {
      display: flex;
      align-items: center;
    }
  }
}

.order-last-list {
  .customer-info {
    h2 {
      font-size: 16px;
    }
    span {
      font-size: 13px;
      color: #999;
      font-weight: 300;
    }
  }
  .order-coupon {
    display: flex;
    justify-content: left;
  }
}

.general-stats-container {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 15px;
  margin-bottom: 20px;

  &__box {
    margin: 0;
    .card-header {
      padding: 5px;
      h2 {
        margin: 0;
      }
    }

    .card-body {
      display: flex;
      justify-content: center;
      flex-direction: column;
      align-items: center;
    }
  }
}

.custom-chart,
.general-stats-container {
  .chart_increase {
    display: flex;
    align-items: center;
    height: auto;
    margin-top: 10px;

    i {
      margin-left: 8px;
    }

    &--positive {
      color: #12c457;
      font-weight: 600;

      span {
        background: rgb(234, 243, 239);
        border-radius: 10px;
        padding: 7px;
      }
    }
    &--negative {
      color: #e84c85;
      font-weight: 600;
    }

    &--neutro {
      span {
        background: rgb(248, 247, 247);
        border-radius: 10px;
        padding: 7px;
      }
    }
  }
}
</style>
